<template>
  <el-dialog :visible.sync="visible" width="850px" :show-close="true" :before-close="handleClose" class="fans-dialog">
    <div class="title">
      <img src="@/assets/xinxin.png" alt="" />
      <p>
        我的粉丝<span v-if="total > 0">({{ total }})</span>
      </p>
    </div>

    <div class="content-dialog" v-loading="loading">
      <div v-if="fansList.length === 0 && !loading" class="empty-img">
        <img class="empty" src="@/assets/listempty.png" alt="" />
      </div>

      <div v-else class="content-inner">
        <div
          v-for="(item, index) in fansList"
          :key="item.userId"
          class="options"
          :class="{'options-last': index + 1 !== fansList.length}"
        >
          <div class="name">
            <p>{{ formatPhoneNumber(item.userName) }}</p>
          </div>
          <p class="action" @click="handleRemoveFans(item, index)" :class="{loading: item.removing}">
            {{ item.removing ? '移除中...' : '移除粉丝' }}
          </p>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import {getFansList, removeFans} from '../../api/consultingService'

export default {
  name: 'FansListDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    employeeId: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      loading: false,
      fansList: [],
      total: 0,
      businessType: '咨询'
    }
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        this.fetchFansList()
      }
    }
  },
  methods: {
    // 获取粉丝列表
    async fetchFansList() {
      this.loading = true
      try {
        const res = await getFansList({businessType: this.businessType, employeeId: this.employeeId})
        if (res.code === 200) {
          this.fansList = res.data.followedVos || []
          this.total = res.data.total || 0
        } else {
          if (res.msg) {
            this.$message.error(res.msg)
          }
        }
      } catch (error) {
        console.error('获取粉丝列表失败:', error)
        // this.$message.error('获取粉丝列表失败，请稍后重试')
      } finally {
        this.loading = false
      }
    },

    // 格式化手机号（脱敏处理）
    formatPhoneNumber(phoneNumber) {
      if (!phoneNumber || typeof phoneNumber !== 'string') {
        return '未设置手机号'
      }

      // 如果是手机号格式（11位数字），进行脱敏处理
      if (/^1[3-9]\d{9}$/.test(phoneNumber)) {
        return phoneNumber.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2')
      }

      // 如果不是标准手机号格式，直接返回
      return phoneNumber
    },

    // 移除粉丝
    async handleRemoveFans(item, index) {
      try {
        await this.$confirm('确定要移除此粉丝吗？', '确认移除粉丝', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })

        // 设置移除状态
        this.$set(item, 'removing', true)

        const res = await removeFans({
          fansUserId: item.userId,
          objectType: '咨询'
        })

        if (res.code === 200) {
          this.$message.success('移除粉丝成功')
          // 从列表中移除
          this.fansList.splice(index, 1)
          this.total = Math.max(0, this.total - 1)
          // 触发父组件刷新数据
          this.$emit('removeFansSuccess')
        } else {
          this.$message.error(res.msg || '移除粉丝失败')
        }
      } catch (error) {
        if (error !== 'cancel') {
          console.error('移除粉丝失败:', error)
          this.$message.error('移除粉丝失败，请稍后重试')
        }
      } finally {
        this.$set(item, 'removing', false)
        this.fetchFansList()
      }
    },

    // 关闭弹窗
    handleClose() {
      this.$emit('update:visible', false)
    }
  }
}
</script>

<style lang="scss" scoped>
.fans-dialog {
  /deep/ .el-dialog__header {
    padding: 0 !important;
  }
  /deep/ .el-dialog__body {
    padding: 20px 0 50px 0;
  }
  /deep/ .el-dialog {
    border-radius: 10px;
    height: auto;
    // max-height: 70vh;
    overflow: auto;
  }
}

.title {
  padding-left: 20px;
  margin-bottom: 31px;
  img {
    width: 31px;
    height: 30px;
    margin-top: 2px;
    margin-right: 10px;
    display: inline-block;
    font-size: 0;
  }
  p {
    font-size: 24px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    line-height: 33px;
    display: inline-block;
    vertical-align: top;
  }
}


.content-dialog {
  height: 371px;
  // overflow: hidden;
}
.content-inner {
  height: 370px;
  // overflow: scroll;
  overflow-y: scroll;
  overflow-x: hidden;
}

.options {
  width: 80%;
  margin: 0 auto 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 0 30px 0;
  .name {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    position: relative;
    cursor: pointer;
    img {
      width: 48px;
      height: 48px;
      border-radius: 50%;
      margin-right: 12px;
    }
    p {
      font-size: 24px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
      line-height: 48px;
    }
    .sex {
      position: absolute;
      top: -5px;
      left: 38px;
      width: 21px;
      height: 21px;
    }
  }
}

.options-last {
  border-bottom: 1px solid #e9e9e9;
}

.empty-img {
  margin: 0 auto;
  overflow: hidden;
}

.empty {
  width: 400px;
  display: block;
  margin: 80px auto;
}

.action {
  background: #5ad3cd;
  display: inline-block;
  line-height: 1;
  cursor: pointer;
  color: #fff;
  text-align: center;
  box-sizing: border-box;
  font-weight: 500;
  padding: 12px 20px;
  font-size: 14px;
  border-radius: 4px;
  transition: all 0.3s;

  &:hover {
    opacity: 0.9;
  }

  &.loading {
    opacity: 0.6;
    cursor: not-allowed;
  }
}
</style>
